import axios from "axios";
import { encryptStorage } from "../../../../constants/EncryptStorage";
import getUrl from "../../../../constants/urlConst";


export function ApiReport() {
  const userToken = encryptStorage.getItem("token");

  const authAxios = axios.create({
    baseURL: getUrl(),
    headers: {
      Authorization: `Bearer ${userToken}`,
    },
  });

  return {
    getLuggageCount: async (model) => {
      try {
        const response = await authAxios.post(getUrl() + "report/luggage-count", model);
        return response.data;
      } catch (error) {
        console.error("Error fetching carriers:", error);
        throw error;
      }
    },

  };
}
